import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const submitArtist = (payload) => api.post("/contact/artist", payload).then(r => r.data);
export const submitFanPartner = (payload) => api.post("/contact/fan-partner", payload).then(r => r.data);
export const getHealth = () => api.get("/health").then(r => r.data);
